import { apiClient } from './api-client';

export interface UserView {
  id: string;
  email: string;
  name: string;
  role: 'ADMIN' | 'EDITOR' | 'REVIEWER' | 'VIEWER';
}

export interface CreatedMember {
  id: string;
  email: string;
  name: string;
  role: UserView['role'];
  temporaryPassword: string;
}

export const usersApi = {
  async list(): Promise<UserView[]> {
    const { data } = await apiClient.get<UserView[]>('/users');
    return data;
  },

  async create(payload: {
    name: string;
    email: string;
    role: UserView['role'];
  }): Promise<CreatedMember> {
    const { data } = await apiClient.post<CreatedMember>('/users', payload);
    return data;
  },

  async updateRole(id: string, role: UserView['role']): Promise<UserView> {
    const { data } = await apiClient.patch<UserView>(`/users/${id}/role`, { role });
    return data;
  },

  async remove(id: string): Promise<{ id: string }> {
    const { data } = await apiClient.delete<{ id: string }>(`/users/${id}`);
    return data;
  },
};
